import React, { Component } from "react";
import "bootstrap/dist/css/bootstrap.css";
import "mdbreact/dist/css/mdb.css";

import Slider from "./Slider";
import HomeCardDeck from "./HomeCardDeck";
import colors from "../../colors";

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: true,
    };
  }

  render() {
    return (
      <div
        // className="ui raised segment cardeck_full"
        className="cardeck_full"

      >
        <div
          className="carddeck_inner"
          style={{

            backgroundColor: colors.background,
          }}
        >

          <Slider />
          <HomeCardDeck />
       
        </div>
      </div>
    );
  }
}

export default Home;
